<template>
  <div>
    <b-img :src="popupImage" fluid :alt="description" @click="showModal()"></b-img>
    <font-awesome-icon
      class="float-right"
      :icon="['fa', 'expand-arrows-alt']"
      size="2x"
      @click="showModal()"
    />
    <p class="font-italic text-center">Click the image above to enlarge it.</p>
    <h6 >{{ description }}</h6>

    <b-modal size="xl" :ref="modalName" :hide-header="true">
      <div class="text-center pt-4">
        <b-img class="pt-2" :src="modalImage" fluid :alt="description"></b-img>
        <h6 class="pt-4">{{ description }}</h6>
      </div>
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()">
          <font-awesome-icon class="mr-2" :icon="['fas', 'times']" />Close
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  props: {
    popupImage: null,
    modalImage: null,
    description: null,
  },

  data() {
    return {
      modalName: "popup-modal-large",
    };
  },

  methods: {
    showModal() {
      this.$refs[this.modalName].show();
    },
  },
});
</script>

<style scoped>
svg.svg-inline--fa.fa-expand-arrows-alt {
  color: white !important;
  position: absolute;
  top: 25px;
  right: 25px;
  cursor: pointer;
}
img {
  cursor: pointer;
}
</style>